import {z} from 'zod';

export const SendOnlineOfferEmailFormSchema = z.object({
  contactPerson: z.string(),
  body: z.string().min(1),
  emailAddress: z.string().email(),
  smtpCredentialsId: z.string(),
});

export type FormValues = z.infer<typeof SendOnlineOfferEmailFormSchema>;
